// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/subscription-article-schema',
  type: 'object',
  required: ['subscriptionTemplateNumber', 'itemNumber', 'itemPriceNumber', 'itemPriceType', 'unitPrice', 'vatRate'],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    subscriptionTemplateNumber: {
      type: 'integer',
    },
    itemId: {
      type: 'string',
      format: 'uuid',
    },
    itemNumber: {
      type: 'integer',
    },
    itemPriceNumber: {
      type: 'integer',
    },
    itemPriceType: {
      type: 'integer',
    },
    name: {
      type: 'string',
      nullable: true,
    },
    currency: {
      type: 'string',
      nullable: true,
    },
    unitPrice: {
      type: 'number',
    },
    vatRate: {
      type: 'number',
    },
    durationInMonths: {
      type: 'integer',
      nullable: true,
    },
    durationInWeeks: {
      type: 'integer',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
